import { ComponentProps, FC } from 'react'
import { IconWrapper } from '../wrapper'

export const IconEmojiNotAMatch: FC<ComponentProps<typeof IconWrapper>> = (props) => {
  const { size = 20, color = 'currentColor' } = props
  return (
    <IconWrapper {...props} size={size}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_15140_44753)">
          <path d="M13.3327 13.3333C13.3327 13.3333 12.0827 11.6666 9.99935 11.6666C7.91602 11.6666 6.66602 13.3333 6.66602 13.3333M7.49935 7.49996H7.50768M12.4993 7.49996H12.5077M18.3327 9.99996C18.3327 14.6023 14.6017 18.3333 9.99935 18.3333C5.39698 18.3333 1.66602 14.6023 1.66602 9.99996C1.66602 5.39759 5.39698 1.66663 9.99935 1.66663C14.6017 1.66663 18.3327 5.39759 18.3327 9.99996Z" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0_15140_44753">
            <rect width="20" height="20" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </IconWrapper>
  )
}
